import React, { useEffect, useState } from 'react'
/* eslint-disable no-console */
const categories = [
  {
    id: 1,
    name: '高評価'
  },
  {
    id: 2,
    name: '子連れ歓迎店'
  }
]

export const categoryImages: any = {
  高評価: '/assets/img/icon-1.png',
  子連れ歓迎店: '/assets/img/icon-2.png',
  'スイーツ・和菓子': '/assets/img/icon-3.png',
  'カフェ・パン': '/assets/img/icon-4.png',
  'バー・レストラン': '/assets/img/icon-5.png',
  '餃子・中華': '/assets/img/icon-6.png',
  'テイクアウト・小売店': '/assets/img/icon-7.png',
  '和食・居酒屋': '/assets/img/icon-8.png',
  '焼肉・ステーキ': '/assets/img/icon-9.png',
  '麺類・ラーメン': '/assets/img/icon-10.png',
  取り寄せグルメ: '/assets/img/icon-11.png',
  その他: '/assets/img/ic_cate_group_10.png'
}

export default function TopMenu (props: any) {
  const [listCategory, setListCategory] = useState(categories as any[])
  const { foodCategoryGroups } = props

  useEffect(() => {
    if (foodCategoryGroups && foodCategoryGroups.length > 0) {
      setListCategory([...categories, ...foodCategoryGroups])
    }
  }, [foodCategoryGroups])

  const getNameCategory = (category: any) => {
    switch (category.name) {
      case '子連れ歓迎店':
        return (
          <div>
            <i className="bi bi-heart-fill icon-heart-a" />
            {category.name}
          </div>
        )
      case 'その他':
        return (
          <div>
            <img src={categoryImages[category.name]} alt="その他" />
            ホテル
          </div>
        )
      default:
        return (
          <div>
            <img src={categoryImages[category.name]} alt={category.name} />
            {category.name}
          </div>
        )
    }
  }

  return (
    <div className="video-fillter mt-3">
      <h2 className="title"><i className="bi bi-play-circle-fill" /> 応援動画を見る</h2>
      <div className="mt-3">
        <div className="video-fillter-list">
          {listCategory.map((category: any) => (
            <button key={category.id} type="button" className="btn btn-lg" onClick={() => props.onSelectCategory(category)}>
              { getNameCategory(category) }
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
